export const darkTheme = {
  primary: '#002A52',
  secondary: '#ff00bf',
  lightgray: '#ccc8c8',
  themewhite: '#ffffff',
};
